import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { T, FONT_BODY } from './styleEditorial';

const STORAGE_KEY = 'finanalyse_launch_banner_closed';
// Fin de l'offre de lancement — affichée en toutes lettres, sans compte à rebours.
// Après cette date, la bannière disparaît d'elle-même.
const OFFER_END = new Date('2026-07-31T23:59:59');
const OFFER_END_LABEL = OFFER_END.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });

export default function LaunchBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const closed = sessionStorage.getItem(STORAGE_KEY);
    if (!closed && new Date() <= OFFER_END) setShow(true);
  }, []);

  const close = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="launch-banner-desktop" style={{
      background: T.ink,
      color: T.paper,
      borderBottom: `1px solid ${T.gold}`,
      padding: '12px 56px 12px 24px',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '10px 20px', flexWrap: 'wrap',
      position: 'relative',
      minHeight: '44px', boxSizing: 'border-box',
      fontSize: '13px',
      fontFamily: FONT_BODY,
      letterSpacing: '0.04em',
    }}>
      <span style={{ fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: T.goldSoft }}>
        Offre de lancement
      </span>

      <span style={{ opacity: 0.92 }}>
        <strong style={{ color: T.goldSoft, fontWeight: 600 }}>−20 %</strong> sur tous les rapports, jusqu'au {OFFER_END_LABEL}
      </span>

      <Link to="/#simulateur" style={{
        display: 'inline-flex', alignItems: 'center',
        padding: '6px 14px',
        background: 'transparent', color: T.paper, textDecoration: 'none',
        fontSize: '13px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase',
        borderBottom: `1px solid ${T.goldSoft}`,
      }}>
        En profiter →
      </Link>

      <button onClick={close} aria-label="Fermer" style={{
        position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)',
        width: '44px', height: '44px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'transparent', border: 'none', borderRadius: '2px',
        color: T.paper, cursor: 'pointer', fontSize: '18px', opacity: 0.6,
        fontFamily: FONT_BODY,
      }}>×</button>
    </div>
  );
}
